// import { applyMiddleware, createStore, combineReducers } from 'redux';
// import { persistReducer, persistStore } from 'redux-persist';
// import thunk from 'redux-thunk';
// import storage from 'redux-persist/lib/storage';
// import reducer from '@store/reducers';
// import { baseApi } from '../services/baseApi';

// const persistConfig = {
//   // configuration object for redux-persist
//   key: 'root',
//   storage, // define which storage to use
//   whitelist: ['Role', 'Auth', 'General', 'School'],
//   blacklist: ['api'], // Don't persist RTK Query cache
// };

// // Combine the original reducer with the API reducer
// const rootReducer = combineReducers({
//   ...reducer,
//   [baseApi.reducerPath]: baseApi.reducer,
// });

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// // Create store with combined middleware
// const middlewares = [thunk, baseApi.middleware];
// const store = createStore(persistedReducer, applyMiddleware(...middlewares));

// // Enable API middleware
// const persistor = persistStore(store);

// export { store, persistor };
import { applyMiddleware, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import reducer from '@store/reducers';
import { baseApi } from '../services/baseApi';
import { backgroundProcessesApi } from '../services/backgroundProcesses';
import { appVersionApi } from '../services/appVersion';

const persistConfig = {
  // configuration object for redux-persist
  key: 'root',
  storage, // define which storage to use
  whitelist: ['Role', 'Auth', 'General', 'School'],
  blacklist: [baseApi.reducerPath, backgroundProcessesApi.reducerPath, appVersionApi.reducerPath], // Don't persist RTK Query cache
};

const persistedReducer = persistReducer(persistConfig, reducer);
// Create store with the thunk middleware and API middlewares
const store = createStore(
  persistedReducer,
  applyMiddleware(thunk, baseApi.middleware, backgroundProcessesApi.middleware, appVersionApi.middleware)
);
const persistor = persistStore(store);

export { store, persistor };
